import { Star } from "lucide-react";

// Google's recognizable review-star gold — deliberately NOT recolored to the
// brand palette; the gold is the trust cue that reads as "Google review".
const GOOGLE_GOLD = "#FBBC04";

export const GoogleStars = ({ size = 12, count = 5, className = "" }) => (
  <span
    aria-hidden="true"
    className={`inline-flex items-center gap-0.5 ${className}`}
    style={{ color: GOOGLE_GOLD }}
  >
    {[...Array(count)].map((_, i) => (
      <Star key={i} size={size} fill="currentColor" strokeWidth={0} />
    ))}
  </span>
);
